import React from "react";
import { ListFacet } from "../../pure/Facets/ListFacet/ListFacet";
import { RangeFacet } from "../../pure/Facets/RangeFacet/RangeFacet";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var FacetContainer = function FacetContainer(_ref) {
  var facets = _ref.facets;
  return ___EmotionJSX(React.Fragment, null, facets.availableFacets.map(function (facet) {
    if (facet.__typename === "SearchListFacet") {
      return ___EmotionJSX(ListFacet, {
        key: facet.id,
        facet: facet
      });
    }

    if (facet.__typename === "SearchRangeFacet") {
      return ___EmotionJSX(RangeFacet, {
        key: facet.id,
        facet: facet
      });
    }

    return null;
  }));
};